package com.ijoin.platform.shortcut

import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.SharedFlow
import kotlinx.coroutines.flow.asSharedFlow

data class ProfileShortcutLaunch(
    val userId: String,
    val displayName: String?,
    val username: String?
)

object ProfileShortcutLauncher {
    private val _events = MutableSharedFlow<ProfileShortcutLaunch>(
        replay = 1,
        extraBufferCapacity = 1
    )

    val events: SharedFlow<ProfileShortcutLaunch> = _events.asSharedFlow()

    fun notifyShortcut(userId: String, displayName: String?, username: String?) {
        _events.tryEmit(ProfileShortcutLaunch(userId, displayName, username))
    }

    fun clearPending() {
        _events.resetReplayCache()
    }
}
